export const flowSessionQueryKey = (flowGeneratorSessionId: number) =>
  ["flow-generator-session", flowGeneratorSessionId] as const;

export const resetFlowSession = (flowGeneratorSessionId: number) => {
  if (!flowGeneratorSessionId) return;

  window.QueryClient.resetQueries({
    queryKey: flowSessionQueryKey(flowGeneratorSessionId),
  }).catch((e) => {
    console.error("Failed to reset flow generator session query", e);
  });
};
